import { TRACKING_CONFIG, type OfficerPositionView } from '@munifocus/contracts-gov';
import { ageSeconds } from './tracking-api';

/** A marker this old is drawn grey: the officer may have stopped moving, or lost signal. */
export const STALE_AFTER_SECONDS = TRACKING_CONFIG.staleAfterSeconds;

export function isStale(o: Pick<OfficerPositionView, 'recordedAt'>, now = Date.now()): boolean {
  return ageSeconds(o.recordedAt, now) > STALE_AFTER_SECONDS;
}

/** The list view's order: live markers first, then by name. */
export function sortForList(
  officers: readonly OfficerPositionView[],
  now = Date.now(),
): OfficerPositionView[] {
  return [...officers].sort(
    (a, b) =>
      Number(isStale(a, now)) - Number(isStale(b, now)) ||
      a.officerName.localeCompare(b.officerName),
  );
}

/**
 * Where the replay marker sits at `index` of a track, and the time it stands
 * for. Clamped, so a slider value past either end lands on the end.
 */
export function replayAt<T extends { recordedAt: string }>(
  points: readonly T[],
  index: number,
): T | null {
  if (points.length === 0) return null;
  return points[Math.min(points.length - 1, Math.max(0, Math.round(index)))];
}

/** Today's date as the supervisor's day picker means it: local, `YYYY-MM-DD`. */
export function localDate(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** The oldest day still inside a retention window of `days`. */
export function oldestReplayDate(days: number, now: Date = new Date()): string {
  const d = new Date(now);
  d.setDate(d.getDate() - days);
  return localDate(d);
}
